import React, { useState, useEffect } from 'react';
import {
  Alert,
  Button,
  Col,
  Container,
  Row,
  Spinner,
  Tab,
  Tabs,
} from "react-bootstrap";

import { useHistory, useLocation, useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import _ from 'lodash';

import PageTitle from "../../components/common/PageTitle";
import UserDetails from "../../components/user-profile-lite/UserDetails";
import UserAccountDetails from "../../components/user-profile-lite/UserAccountDetails";
import DesignsList from "../../components/user-profile-lite/DesignsList";
import SubscriptionsList from '../../components/user-profile-lite/SubscriptionsList';
import AddSubscription from '../../components/user-profile-lite/AddSubscription';

import { userActions } from '../../actions';

const UserProfile = () => {
  const history = useHistory();
  const location = useLocation();
  const { _userId } = useParams();
  const dispatch = useDispatch();
  const user = useSelector(state => state.user.user);
  const loading = useSelector(state => state.user.loading);
  const error = useSelector(state => state.user.error);
  const designs = useSelector(state => state.user.designs);
  const designsState = useSelector(state => state.user.designsState);
  const subscriptions = useSelector(state => state.subscription.subscriptions);
  const subscriptionsState = useSelector(state => state.subscription.currentStatus);
  const [activeTab, setActiveTab] = useState('details');

  useEffect(() => {
    dispatch(userActions.getUser(_userId));
  }, [_userId, dispatch]);

  useEffect(() => {
    if (activeTab !== 'designs') return;
    dispatch(userActions.getDesigns(_userId));
  }, [_userId, activeTab, dispatch]);

  const goBack = () => {
    const destination = location.state && location.state.from;
    history.push(destination || '/users-list');
  };


  return (
    <Container fluid className="main-content-container px-4">
      <Row noGutters className="page-header py-4">
        <PageTitle title="User Details" subtitle="Users" className="ml-sm-auto mr-sm-auto" />
        <Col className="headerButtonHolder text-right">
          {activeTab === 'subscriptions' && <AddSubscription userId={_.get(user, '_id')} />}
          <Button variant="outline-secondary" onClick={goBack}>
            <i className="material-icons mr-1">arrow_back</i>
            Back to users
          </Button>
        </Col>
      </Row>
      {error && (
        <Alert variant="danger">
          <span>{error}</span>
          <Button
            variant="outline-danger"
            size="sm"
            className="ml-3"
            onClick={() => dispatch(userActions.getUser(_userId))}
          >
            Retry
          </Button>
        </Alert>
      )}
      {loading && !user ? (
        <div className="user-profile-loading" role="status">
          <Spinner animation="border" variant="primary" />
          <span>Loading user details...</span>
        </div>
      ) : user ? (
      <Tabs
        activeKey={activeTab}
        id="user-profile-tabs"
        onSelect={eventKey => setActiveTab(eventKey)}
      >
        <Tab eventKey="details" title="Details">
          <Row>
            <Col lg="4">
              <UserDetails user={user} />
            </Col>
            <Col lg="8">
              <UserAccountDetails user={user} />
            </Col>
          </Row>
        </Tab>
        <Tab eventKey="subscriptions" title="Subscriptions">
          <Row>
            <Col>
              <SubscriptionsList
                data={subscriptions}
                loading={subscriptionsState === 'loading'}
              />
            </Col>
          </Row>
        </Tab>
        <Tab eventKey="designs" title="Designs">
          <Row>
            <Col>
              <DesignsList data={designs} loading={designsState === 'request'} />
            </Col>
          </Row>
        </Tab>
      </Tabs>
      ) : !error && (
        <Alert variant="warning">This user could not be found.</Alert>
      )}
    </Container >
  )
}

export default UserProfile;
